import { DefaultQueryParams } from '@frontend/api-utils';
import { ChartClient } from '@frontend/chart/api';
import { VendingPackageVolumeByProductListChart } from '@frontend/chart/components';
import { Chart, ChartQueryParam } from '@frontend/chart/types';
import { useEffect, useState } from 'react';

import { getLast30DaysChartRange } from '../../pudo/last-30-days-chart-range';
import { Last30DaysVendingPackageVolumeByProductListChartProps } from './last-30-days-vending-consumption-rate-by-product-list-chart.component';

export const useLast30DaysVendingPackageVolumeByProductListChart = (props: Last30DaysVendingPackageVolumeByProductListChartProps) => {
    const [data, setData] = useState<Chart | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!props.accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        const { after, before } = getLast30DaysChartRange();

        ChartClient.fetchChartData(props.accountId, VendingPackageVolumeByProductListChart.definition, {
            [DefaultQueryParams.AFTER]: after,
            [DefaultQueryParams.BEFORE]: before,
            [ChartQueryParam.SORT_DIRECTION]: 'desc'
        })
            .then((chart) => {
                if (!cancelled) {
                    setData(chart);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setData(undefined);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.accountId]);

    return { data, isLoading };
};
